import React, { useRef } from 'react'
import Logo from '../assets/logo.png';
import Logo2 from '../assets/logo2.png';

import jsPDF from 'jspdf';
import html2canvas from 'html2canvas';
import { useNavigate } from 'react-router-dom';


const SaleOrderInvoice = ({setShowDetail, selectedOrder, userData}) => {
const invoiceRef = useRef();
const navigate = useNavigate();

  const formatDateTime = (dateString) => {
    const date = new Date(dateString);
    return date.toLocaleString('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
      hour: '2-digit',
      minute: '2-digit',
      hour12: true
    }).replace(',', '');
  };


  const handleDownloadInvoice = () => {
    const input = invoiceRef.current;
    if (!input) return;
    html2canvas(input, { scale: 1, logging: false }).then(canvas => {
      const imgData = canvas.toDataURL('image/png');
      // const pdf = new jsPDF('p', 'pt', 'a5');
    const pdf = new jsPDF({
        orientation: 'p',
        unit: 'mm',
        format: [297, 105]
    });
      const pdfWidth = pdf.internal.pageSize.getWidth();
      const pdfHeight = pdf.internal.pageSize.getHeight();
  
      const imgProps = pdf.getImageProperties(imgData);
      const imgWidth = pdfWidth;
      const imgHeight = (imgProps.height * imgWidth) / imgProps.width;
  
      let heightLeft = imgHeight;
      let position = 0;
  
      pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
      heightLeft -= pdfHeight;
  
      while (heightLeft > 0) {
        position = heightLeft - imgHeight;
        pdf.addPage();
        pdf.addImage(imgData, 'PNG', 0, position, imgWidth, imgHeight);
        heightLeft -= pdfHeight;
      }
  
      pdf.save(`invoice_order_${selectedOrder.id}.pdf`);
    }).catch(err => {
      console.error('Error generating PDF:', err);
    });
  };
  
  
  const handlePrintInvoice = () => {
    // Safely parse order_items and free_items, fallback to empty arrays if invalid or undefined
    const orderItems = selectedOrder.order_items ? JSON.parse(selectedOrder.order_items) : [];
  
    const balance =
  (Number(selectedOrder.total_amount || 0) +
    Number(selectedOrder.charges || 0)) -
  Number(selectedOrder.received || 0);

const balanceHtml =
  balance > 0
    ? `<p style='margin: 0'><strong>Due: ₹${Math.round(balance)}</strong></p>`
    : `<p style='margin: 0'><strong>Balance: ₹${Math.abs(Math.round(balance))}</strong></p>`;
    const windowContent = `
      <html>
        <head>
          <title>Print Invoice</title>
          <style>
            @page {
              size: 76mm auto;
              margin: 0mm;
            }
  
            html, body {
              width: 76mm;
              padding: 0;
              margin: 0;
              font-family: "Noto Sans Mono", monospace;
              font-size: 11px;
              font-weight: bold;
            }
  
            .receipt {
              width: 74mm;
              padding: 2px;
              box-sizing: border-box;
            }
  
            .center {
              text-align: center;
            }
  
            .right {
              text-align: right;
              margin: 0;
              padding: 0;
            }
  
            table {
              width: 100%;
              border-collapse: collapse;
            }
  
            td, th {
              padding: 1px;
              word-wrap: break-word;
              word-break: break-word;
              vertical-align: top;
              font-size: 10px;
              font-weight: semibold;
                          font-family: "Noto Sans Mono", monospace;
            }
  
  
            .item-name {
              width: 50%;
              white-space: normal;
            }
  
            .line {
              border-top: 1px dashed #000;
              margin: 4px 0;
            }
          </style>
        </head>
        <body>
          <div class="receipt">
            <div class="center">
              <img src="${Logo2}" style="height: 40px;" />
   
              <p style="font-size:15px;margin:0px;"><strong>${userData.shop_name}</strong></p>
              <p style="margin:0px;">${userData.address}, ${userData.city}</p>
            </div>
  
            <div class="line"></div>
  
            <p style="margin-bottom:0px;">Order ID: #${selectedOrder.id}</p>
            <p style="margin-top:0px;">Date: ${formatDateTime(selectedOrder.order_date)}</p>
  
            <div class="line"></div>
  
            <p style="margin-bottom:0px;">Customer Name: #${selectedOrder.name}</p>
            <p style="margin-bottom:0px;margin-top:0px;">Mobile No: #${selectedOrder.mobile}</p>
          <p style="margin-top:0px;">Address: ${selectedOrder.address} ${selectedOrder.city} ${selectedOrder.state} ${selectedOrder.pincode}</p>
  
                      <div class="line"></div>
  
            <table>
                <tr>
                  <th>SL</th>
                  <th>Item</th>
                  <th class="right">Qty</th>
                  <th class="right">SP</th>
                  <th class="right">Amt</th>
                </tr>
              <tbody>
                ${orderItems.map((item, index) => {

                  const total = item.price * item.quantity;
  
                  return `
                    <tr>
                    <td>${index + 1}</td>
                      <td class="item-name">${item.name} ${item.mrp}/-</td>
                      <td class="right">${item.quantity}</td>
                      <td class="right">${parseFloat(item.price).toFixed(2)}</td>
                      <td class="right">${total.toFixed(2)}</td>
                    </tr>
                  `;
                }).join('')}
  
            
              </tbody>
            </table>
  
<br />

${selectedOrder.remark
  ? `<span>Remark: ${selectedOrder.remark}</span><br />`
  : ''}
                     ${selectedOrder.charges != null && selectedOrder.charges > 0 ? 
                      `                         <p class="right">Sub Total: ₹${Math.round(Number(selectedOrder.total_amount))}</p>
                       <p class="right">Transport Charges: ₹${Math.round(Number(selectedOrder.charges))}</p>`
: ''                     }
                     

            <p class="right"><strong>Grand Total: ₹${Math.round(Number(selectedOrder.total_amount) + Number(selectedOrder.charges))}</strong></p>
            <span>Received: ₹${Math.round(Number(selectedOrder.received))}  ${balanceHtml}</span>

            <div class="line"></div>
  
            <p class="center">Thank you for shopping!</p>
          </div>
  
          <script>
            window.onload = function() {
              window.print();
            };
          </script>
        </body>
      </html>
    `;
  
    const printWindow = window.open('', '_blank');
    printWindow.document.open();
    printWindow.document.write(windowContent);
    printWindow.document.close();
  };
  

    let items = [];

try {
  items =
    typeof selectedOrder?.order_items === "string"
      ? JSON.parse(selectedOrder.order_items)
      : selectedOrder?.order_items || [];
} catch (e) {
  items = [];
}


  return (
    
    <>
    <section className='detail-outer'>
        <div className='detail-inner'>

            <div className='d-md-flex justify-content-between'>
<button className='close-btn mb-2' onClick={() => setShowDetail(false)}>Go Back</button>

            <div className='d-flex justify-content-between'>
<button className='edit-btn mb-2' onClick={handlePrintInvoice}>Print Now</button>&nbsp;&nbsp;
<button className='edit-btn mb-2' onClick={handleDownloadInvoice}>Download Invoice</button></div>
            </div>


<p className='mt-3 fw-bold fs-5'>Order Details</p>

<div className='detail-bill col-md-9 mx-auto' ref={invoiceRef}>

<img src={Logo} className='bill-watermark' alt='watermark' />

<p className='text-center fs-4 fw-bold'>ORDER INVOICE</p>

<div className='d-flex justify-content-between'>

<div>
<p className='fw-bold my-0 fs-5'>Order Id: #{selectedOrder.id}</p>
<p className='para-text fw-semibold fs-5'>{formatDateTime(selectedOrder.order_date)}</p>
    <p className='fw-bold my-0 fs-5'>Customer Details:</p>
<p className='para-text fw-semibold fs-5'>{selectedOrder.name}<br />{selectedOrder.mobile}<br />{selectedOrder.email}</p>
</div>


<div>
    <p className='fw-bold my-0 fs-5'>Seller Details:</p>
<p className='para-text fw-semibold fs-5'>{userData.shop_name}<br />{userData.gst_no ? <span>GST No: {userData.gst_no}<br /></span> : ''}Address: {userData.address} {userData.city} {userData.state} {userData.pincode}</p>

        <p className='fw-bold my-0 fs-5'>Delivery Address:</p>
        <p className='para-text fw-semibold fs-5'>{selectedOrder.address} {selectedOrder.city} {selectedOrder.state} {selectedOrder.pincode}</p>
</div>


</div>


<div className='table-responsive'>
<table className='w-100 fs-5'>

    <tr className='order-tr'>
        <th className='order-th' style={{flex: '0.4'}}>S No</th>
        <th className='order-th' style={{flex: '4'}}>Product Details</th>
        <th className='order-th'>MRP</th>
        <th className='order-th'>Sale Price</th>
        <th className='order-th'>Qty</th>
        <th className='order-th'>SubTotal</th>
    </tr>

{items.map((item, idx) => {

  
  return (
    <tr key={idx} className='order-tr'>
      <td className='order-td fw-semibold' style={{flex: '0.4'}}>{idx + 1}</td>
      <td className='order-td fw-semibold para-text' style={{flex: '4'}}>
        {item.name}</td>
      <td className='order-td fw-semibold'>₹{item.mrp}</td>
      <td className='order-td fw-semibold'>₹{item.price}</td>
      <td className='order-td fw-semibold'>{item.quantity}</td>
      <td className='order-td fw-semibold'>₹{(item.amount).toFixed(2)}</td>
    </tr>
  );
})}
</table> 
</div>



<p className='para-text fw-semibold mt-3 fs-4'>      Transport Charges: ₹{selectedOrder.charges}<br />
Payment Mode: {selectedOrder.payment_mode}<br />
Remark: {selectedOrder.remark || 'NA'}</p>

<p className='para-text fw-semibold text-end fs-4'>
        Grand Total: ₹{Math.round(
    Number(selectedOrder.total_amount || 0) +
    Number(selectedOrder.charges || 0)
  )}<br />
<span className='text-success'>Received: ₹{Math.round(selectedOrder.received)}</span>
{Math.round(Math.round(
    (Number(selectedOrder.total_amount || 0) +
    Number(selectedOrder.charges || 0)) - Number(selectedOrder.received || 0)
  )) > 0 ? (
    <><br />
<span className='text-danger'>Due: ₹{Math.round(Math.round(
    (Number(selectedOrder.total_amount || 0) +
    Number(selectedOrder.charges || 0)) - Number(selectedOrder.received || 0)
  ))}</span>
    </>
   ) : 
  (
     <><br />
<span className='text-danger'>Balance: ₹{Math.abs(Math.round(Math.round(
    (Number(selectedOrder.total_amount || 0) +
    Number(selectedOrder.charges || 0)) - Number(selectedOrder.received || 0)
  )))}</span>
    </>
  )}
</p>



</div>

{/* detail bill ends */}

        </div>
    </section>

    </>
  )
}

export default SaleOrderInvoice